/**
 * Shared router constants of our application.
 */
export const ROUTES_CONSTANTS = {
  NETWORK_TEST: { path: 'network-test', title: 'NetworkTest', breadcrumb: 'NetworkTest' },
  MUTUA_NETWORK_TEST: { path: 'mutua-network-test', title: 'MutuaNetworkTest', breadcrumb: 'MutuaNetworkTest' },
  ROOM: { path: 'room', title: 'Room', breadcrumb: 'Room' },
  VIDEOCONFERENCE: { path: 'videoconference', title: 'Videoconference', breadcrumb: 'Videoconference' },
  NO_CONTENT: { path: '**' }
};
